import { createAction } from '@reduxjs/toolkit';

export const logoutAgentAction = createAction('LOGOUT_AGENT');
